module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Categoria",
      "columns": 3,
      "required": true,
      "error": _vm.getError('category', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categorySelected),
      expression: "categorySelected"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.categorySelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.code
      }
    }, [_vm._v(_vm._s(category.label))])
  }), 0)]), _vm._v(" "), (_vm.categorySelected !== null && _vm.childCategories.length > 0) ? _c('form-group', {
    attrs: {
      "label": "Categoria de nível 2",
      "columns": 3,
      "required": true,
      "error": _vm.getError('childCategorySelected', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.childCategorySelected),
      expression: "childCategorySelected"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.childCategorySelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.childCategories), function(childCategory) {
    return _c('option', {
      domProps: {
        "value": childCategory.code
      }
    }, [_vm._v(_vm._s(childCategory.label))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Certificações",
      "columns": 3,
      "required": true,
      "error": _vm.getError('certification', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.certification),
      expression: "product.certification"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.product, "certification", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.certificationOptions), function(certification) {
    return _c('option', {
      domProps: {
        "value": certification
      }
    }, [_vm._v(_vm._s(certification))])
  }), 0)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Código de certificações",
      "columns": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.certificationCode),
      expression: "product.certificationCode"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.certificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "certificationCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Itens inclusos",
      "columns": 3,
      "required": true,
      "error": _vm.getError('includedItems', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.includedItems),
      expression: "product.includedItems"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.includedItems)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "includedItems", $event.target.value)
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b06509","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/carrefour/provide/Product.vue
// module id = 2877
// module chunks = 0